export const getTranslationSuffix = (context) => {
    switch(context) {
        case 'ADD_CONTACT':
            return '.addContact';
        case 'PUBLIC_REGISTRATION':
            return '.public';
        default:
            return '';
    }
}